import { faEarthAmericas } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ShoppingCartsContext } from 'context/ShoppingCartsContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { tss } from 'tss-react';

import MenuPlan from 'classes/MenuPlan/Search/MenuPlan';
import 'components/desktop/MenuPlan/Search/SearchResultList.scss';

interface IProps {
	menuPlan: MenuPlan;
	reloadMenuPlanList: () => void;
	setSelectedMenuPlanId: (id: string | null) => void;
}

export const PublishButtons = (props: IProps) => {
	const { classes, cx } = useStyles();
	const { t } = useTranslation();
	const { initializeWithoutDetails: initializeShoppingCartsWithoutDetails } =
		useContext(ShoppingCartsContext);

	const handleClose = async (): Promise<void> => {
		Swal.fire({
			title: t('menuPlan:CLOSE_MENU_PLAN_TITLE'),
			showCancelButton: true,
			confirmButtonText: t('shoppingCart:CLOSE'),
			cancelButtonText: t('_general:CANCEL'),
		}).then(async (result) => {
			if (result.isConfirmed) {
				await props.menuPlan.close();
				initializeShoppingCartsWithoutDetails();
				props.reloadMenuPlanList();
				Swal.fire(t('menuPlan:MENU_PLAN_CLOSED'), '', 'success');
			}
		});
	};

	const handleRevoke = async (): Promise<void> => {
		Swal.fire({
			title: t('menuPlan:REVOKE_MENU_PLAN_TITLE'),
			showCancelButton: true,
			confirmButtonText: t('menuPlan:REVOKE'),
			cancelButtonText: t('_general:CANCEL'),
		}).then(async (result) => {
			if (result.isConfirmed) {
				await props.menuPlan.revoke();
				initializeShoppingCartsWithoutDetails();
				props.reloadMenuPlanList();
				Swal.fire(t('menuPlan:MENU_PLAN_REVOKED'), '', 'success');
			}
		});
	};

	if (props.menuPlan.publishStatus === 'Editing') {
		return (
			<button
				className={cx('btn btn-outline-secondary btn-sm', classes.button)}
				onClick={(e) => {
					e.preventDefault();
					props.setSelectedMenuPlanId(props.menuPlan.id);
				}}
			>
				<FontAwesomeIcon icon={faEarthAmericas} className={classes.icon} />
				{t('_general:PUBLISH')}
			</button>
		);
	}
	if (props.menuPlan.publishStatus === 'Published') {
		return (
			<div className={cx('input-group', classes.buttonGroup)}>
				<button
					className={cx('btn btn-outline-secondary btn-sm', classes.button)}
					onClick={(e) => {
						e.preventDefault();
						handleRevoke();
					}}
				>
					<FontAwesomeIcon icon={faEarthAmericas} className={classes.icon} />
					{t('menuPlan:REVOKE')}
				</button>
				<button
					className={cx('btn btn-outline-danger btn-sm', classes.button)}
					onClick={(e) => {
						e.preventDefault();
						handleClose();
					}}
				>
					<FontAwesomeIcon icon={faEarthAmericas} className={classes.icon} />
					{t('shoppingCart:CLOSE')}
				</button>
			</div>
		);
	}
	return <></>;
};

const useStyles = tss.create({
	icon: {
		marginRight: '5px',
	},
	button: {
		cursor: 'pointer',
	},
	buttonGroup: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: '5px',
	},
});
